<template>
    <!-- 费用管理  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[8, 4]" bottom="-100px" direction="flex-end" :rbgStyle="{ width: '80%' }" />
</template>

<script>
import SubPage from "./components/SubPage.vue";
export default {
    name: 'cost',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--31.png",
            bg: "/img/pay/0-_BG-3.png",
        }
    },
    computed: {
        title() {
            return this.$t('cost.title');
        },
        subtitle() {
            return this.$t('cost.subtitle');
        },
        description() {
            return [this.$t('cost.description')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>
